module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fBQmH"))).then(() => module.bundle.root('hEqeo'));